import CreatePayment from './create-payment';
import { mask } from './helpers';
import { fetchData } from './fetch';

window.addEventListener('load', () => {
  const PinCodeInputs = document.querySelectorAll('.input-pin-code');

  const addressControlBtns = document.querySelectorAll(
    '.profile-item-control-btn',
  );
  const phoneInput = document.querySelector('.profile-phone');
  const phoneInputMobile = document.querySelector(
    '.mobile-profile-information-form .profile-phone',
  );

  let birthdayPicker = document.querySelector('.birtday-input');
  let birthdayPickerMobile = document.querySelector(
    '.mobile-profile-information-form .birtday-input',
  );

  const birthdayText = document.querySelector('.birthday-text');
  const birthdayTextMobile = document.querySelector(
    '.mobile-profile-information-form .birthday-text',
  );

  const profileInformationForm = document.querySelector(
    '.profile-information-form',
  );
  const profileInformationFormMobile = document.querySelector(
    '.mobile-profile-information-form .profile-information-form',
  );
  const emailInput = document.querySelector('.profile-email-input');
  const emailInputMobile = document.querySelector(
    '.mobile-profile-information-form .profile-email-input',
  );

  const emailSpecialOffer = document.querySelector('.email-special-offer');
  const emailSpecialOfferMobile = document.querySelector(
    '.profile-information-form .email-special-offer',
  ); // может не быть

  const emailSpecialOfferWrapper = document.querySelector(
    '.profile-information-form .slide-checkbox',
  );
  const emailSpecialOfferWrapperMobile = document.querySelector(
    '.mobile-profile-information-form .slide-checkbox',
  ); // ?

  const profileName = document.querySelector('.profile-name-input');
  const profileNameMobile = document.querySelector(
    '.mobile-profile-information-form  .profile-name-input',
  );

  const confirmBirthdayWrapper = document.querySelector(
    '.confirm-birthday-popup-wrapper',
  );
  const confirmBirthdayWrapperMobile = document.querySelector(
    '.mobile-profile-information-form .confirm-birthday-popup-wrapper',
  );
  const confirmBirthdayButton = document.querySelector(
    '.confirm-birthday-popup-wrapper .confirm-button',
  );
  const confirmBirthdayButtonMobile = document.querySelector(
    '.mobile-profile-information-form .confirm-birthday-popup-wrapper .confirm-button',
  );

  const activeOrdersList = document.querySelector('.active-orders-list');
  const historyOrdersList = document.querySelector(
    '.complete-orders .history-orders',
  );

  const historyOrdersListMobile = document.querySelector(
    '.mobile-history-orders__blocks',
  );

  const moreHistoryOrdersButton = document.querySelector(
    '.more-history-orders',
  );
  const moreHistoryOrdersButtonMobile = document.querySelector(
    '.more-history-orders-mobile',
  );
  const activeOrdersEmptyText = document.querySelector(
    '.active-orders-empty-text',
  );
  const completeOrdersEmptyText = document.querySelector(
    '.complete-orders-empty-text',
  );
  const cardBindForm = document.querySelector('.card-bind-form');
  const cardInputs = document.querySelectorAll('.card-input');
  const cardSubmit = document.querySelector('.card-submit');
  const termUrlInput = document.querySelector('.term-url-link');
  const logoutForm = document.querySelector('.logout-form');
  const profileNameErrors = document.querySelector('.profile-name-errors');
  const profileNameErrorsMobile = document.querySelector(
    '.mobile-profile-information-form .profile-name-errors',
  );

  if (PinCodeInputs.length) {
    PinCodeInputs.forEach((item) => {
      item.addEventListener('input', (e) => {
        var maxLength = 4;
        if (e.target.value.length > maxLength) {
          e.target.value = e.target.value.substring(0, maxLength);
        }
      });
    });
  }

  // if (profileName) {
  //   profileName.addEventListener('input', (e) => {
  //     const { value:initValue } = e.target;
  //     let value = initValue;

  //     if (value.match(/\s\s+/g)?.length > 1) {
  //       value = value.trim();
  //     }

  //     value = value.replace(/[^A-ZА-Я\-]/gi, ' ').replace(/\s\s+/g, ' ').substring(0, 24)

  //     profileName.value = value;

  //     if (value.length > 1) {
  //       profileNameErrors.innerHTML = ''
  //     }

  //   });
  //   profileName.addEventListener("blur", (e) => {
  //     profileName.value = profileName.value.trim()
  //   })
  // }

  if (addressControlBtns) {
    [].forEach.call(addressControlBtns, (item) => {
      item.addEventListener('click', () => {
        const parentElement = item.closest('.profile-list-item');

        if (parentElement) {
          parentElement.classList.toggle('active');
        }
      });
    });
  }

  // if (phoneInput && phoneInput.value.length) {
  //   mask(phoneInput, '+_ ___ ___ __ __');
  // }

  // const months = [
  //   'Января',
  //   'Февраля',
  //   'Марта',
  //   'Апреля',
  //   'Мая',
  //   'Июня',
  //   'Июля',
  //   'Августа',
  //   'Сентября',
  //   'Октября',
  //   'Ноября',
  //   'Декабря',
  // ];

  // if (birthdayPicker) {
  //   pickmeup.defaults.locales['ru'] = {
  //     days: [
  //       'Воскресенье',
  //       'Понедельник',
  //       'Вторник',
  //       'Среда',
  //       'Четверг',
  //       'Пятница',
  //       'Суббота',
  //     ],
  //     daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  //     daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  //     months: [
  //       'Январь',
  //       'Февраль',
  //       'Март',
  //       'Апрель',
  //       'Май',
  //       'Июнь',
  //       'Июль',
  //       'Август',
  //       'Сентябрь',
  //       'Октябрь',
  //       'Ноябрь',
  //       'Декабрь',
  //     ],
  //     monthsShort: [
  //       'Янв',
  //       'Фев',
  //       'Мар',
  //       'Апр',
  //       'Май',
  //       'Июн',
  //       'Июл',
  //       'Авг',
  //       'Сен',
  //       'Окт',
  //       'Ноя',
  //       'Дек',
  //     ],
  //   };

  //   let date = new Date(Date.now());

  //   if (birthdayPicker.value) {
  //     date = new Date(birthdayPicker.value);

  //     const day = date.getDate();
  //     const month = months[date.getMonth()];
  //     const year = date.getFullYear();

  //     birthdayText.classList.remove('gray-text');
  //     birthdayText.textContent = `${day} ${month} ${year}`;
  //   }

  //   pickmeup('.birtday-input', {
  //     format: 'Y-m-d',
  //     locale: 'ru',
  //     date,
  //     hide_on_select: true,
  //     title_format: 'B',
  //     default_date: false,
  //   });

  //   birthdayPicker.addEventListener('pickmeup-change', (e) => {
  //     const { date } = e.detail;

  //     const day = date.getDate();
  //     const month = months[date.getMonth()];
  //     const year = date.getFullYear();

  //     if (birthdayText.classList.contains('gray-text')) {
  //       birthdayText.classList.remove('gray-text');
  //     }

  //     birthdayText.textContent = `${day} ${month} ${year}`;
  //   });
  // }

  // if (confirmBirthdayButton) {
  //   confirmBirthdayButton.addEventListener('click', () => {
  //     if (birthdayPicker) {
  //       birthdayPicker.dataset.value = birthdayPicker.value;
  //     }

  //     confirmBirthdayWrapper.classList.remove('active');
  //   });
  // }

  // if (emailInput) {
  //   emailInput.addEventListener('input', (e) => {
  //     const emailIsValid = /.+@.+\..+/gi.test(e.target.value);

  //     if (!emailIsValid) {
  //       emailInput.classList.add('error');
  //     } else {
  //       emailInput.classList.remove('error');

  //       if (emailSpecialOfferWrapper) {
  //         emailSpecialOfferWrapper.classList.remove('disabled');
  //       }

  //       if (emailSpecialOffer) {
  //         emailSpecialOffer.removeAttribute('disabled');
  //       }
  //     }
  //   });
  // }

  // if (profileInformationForm) {
  //   profileInformationForm.addEventListener('submit', (e) => {
  //     const birthday = birthdayPicker.value;
  //     const prevBirthday = birthdayPicker.dataset.value;

  //     if (profileName.value.length < 2) {
  //       e.preventDefault();
  //       profileNameErrors.innerHTML = '<li>Слишком короткое имя</li>'
  //     }

  //     if (prevBirthday !== birthday) {
  //       e.preventDefault();

  //       if (confirmBirthdayWrapper) {
  //         confirmBirthdayWrapper.classList.add('active');
  //       }
  //     }
  //   });
  // }

  addActionsToForm(
    phoneInput,
    birthdayPicker,
    birthdayText,
    profileInformationForm,
    emailInput,
    emailSpecialOffer,
    emailSpecialOfferWrapper,
    confirmBirthdayWrapper,
    confirmBirthdayButton,
    profileName,
    profileNameErrors,
    '.birtday-input',
  );

  addActionsToForm(
    phoneInputMobile,
    birthdayPickerMobile,
    birthdayTextMobile,
    profileInformationFormMobile,
    emailInputMobile,
    emailSpecialOfferMobile,
    emailSpecialOfferWrapperMobile,
    confirmBirthdayWrapperMobile,
    confirmBirthdayButtonMobile,
    profileNameMobile,
    profileNameErrorsMobile,
    '.mobile-profile-information-form .birtday-input',
  );

  let historyOrdersCount = 10;
  let historyOrdersOffset = 0;

  const statuses = {
    delivery: {
      'accepted': 'Ожидает подтверждение',
      'delivered': 'Доставлен',
      'confirmed': 'Подтвержден',
      'preparing': 'Готовится',
      'cancelled': 'Отменен',
      'closed': 'Закрыт',
      'onw': 'Заказ в пути',
      'processing': 'Заказ в обработке',
      'payment-await': 'Заказ в обработке',
      'cook-done': 'Собираем заказ'
    },
    'delivery-togo': {
      'accepted': 'Ожидает подтверждение',
      'delivered': 'Доставлен',
      'confirmed': 'Подтвержден',
      'preparing': 'Готовится',
      'cancelled': 'Отменен',
      'closed': 'Закрыт',
      'onw': 'Заберите заказ',
      'processing': 'Заказ в обработке',
      'payment-await': 'Заказ в обработке',
      'cook-done': 'Собираем заказ'
    },
    cafe: {
      'accepted': 'Ожидает подтверждение',
      'delivered': 'Доставлен',
      'confirmed': 'Подтвержден',
      'preparing': 'Готовится',
      'cancelled': 'Отменен',
      'closed': 'Закрыт',
      'onw': 'Заберите заказ',
      'processing': 'Заказ в обработке',
      'payment-await': 'Заказ в обработке',
      'cook-done': 'Собираем заказ'
    }
  };

  let ordersListTimeout;
  let updateOrdersLists;

  const updateHistoryOrders = (orders) => {
    orders.forEach((order) => {
      const orderItem = document.createElement('li');
      const orderItemMobile = document.createElement('div');
      orderItemMobile.classList.add('profile-info-block');

      const nextDate = new Date(order.createdAt);
      let day = nextDate.getDate();
      if (nextDate.getDate() < 10) {
        day = '0' + day;
      }
      let month = nextDate.getMonth() + 1;
      if (nextDate.getMonth() + 1 < 10) {
        month = '0' + month;
      }

      let content = '';
      let zharcoinsRecieved = '';

      let priceString = order.total / 100;

      if (priceString.toString().includes('.00')) {
        priceString = priceString.toString().replace('.00', '');
      }
      if (order.status == 'cancelled') {
        content = `<div class="canceled-tag placeholder-text bold">${
          statuses[order.orderType][order.status]
        }</div>`;
      } else {
        content = `
          <form method="POST" action="/orders/${order.id}/repeat">
            <button type="submit" class="repeat-button placeholder-text bold">Повторить</button>
          </form>
          `;
      }

      if (historyOrdersList) {
        const loyaltyProgram = historyOrdersList.dataset.loyalty;

        let zharcoinsReceivedFormatted = (
          order.zharcoinsReceived / 100
        ).toFixed(2);

        if (zharcoinsReceivedFormatted.toString().includes('.00')) {
          zharcoinsReceivedFormatted = zharcoinsReceivedFormatted
            .toString()
            .replace('.00', '');
        }

        if (loyaltyProgram) {
          zharcoinsRecieved = `<div class="order-bonus bold placeholder-text"><strong>Начислено жаркоинов: ${zharcoinsReceivedFormatted}</strong></div>`;
        }
      }

      const products = order.cartItems.map((product) => {
        let productName;

        if (product.parent) {
          productName = ` ${product.parent.name}, ${product.name}`;
        } else {
          productName = `${product.name}`;
        }

        return `${productName} ${product.quantity} шт.`;
      });

      orderItem.classList.add('profile-info-block');

      let addressTitle;

      if (order.orderType === 'delivery') {
        addressTitle = 'Доставка';
      } else if (order.orderType === 'cafe-togo') {
        addressTitle = 'Обед в кафе';
      } else if (order.orderType === 'cafe') {
        addressTitle = 'В кафе';
      } else if (order.orderType === 'delivery-togo') {
        addressTitle = 'Самовывоз';
      }

      orderItem.innerHTML = `
            <a href="/profile/orders/${
              order.id
            }" class="history-order-link"></a>
            <div class="profile-info-block__header">
              <div class="profile-info-block__titles-wrapper">
                <h4 class="profile-info-block__title">Заказ ${
                  order.number ? '№ ' + order.number : ''
                } от ${day}.${month}.${nextDate.getFullYear()}</h4>
                <div class="profile-info-block__subtitle text-medium">
                  <div class="profile-info-block__price">
                    ${priceString} ₽
                  </div><span>•</span>${statuses[order.orderType][order.status]}
                </div>
              </div>

            </div>
            <div class="profile-info-block__wrapper">
            <div class="profile-info-block__body secondary-info-blocks">

            ${
              order &&
              order.cartItems &&
              order.cartItems[0] &&
              order.cartItems[0].image &&
              order.cartItems[0].type == 'pizza' &&
              order.cartItems[0].isSlice != true
                ? `<div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[0].parent.image}" alt="product" />
                    </div>`
                : order &&
                  order.cartItems &&
                  order.cartItems[0] &&
                  order.cartItems[0].image
                ? `
                     <div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[0].image}" alt="product" />
                    </div>
              `
                : ''
            }

            ${
              order &&
              order.cartItems &&
              order.cartItems[1] &&
              order.cartItems[1].image &&
              order.cartItems[1].type == 'pizza' &&
              order.cartItems[1].isSlice != true
                ? `<div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[1].parent.image}" alt="product" />
                    </div>`
                : order &&
                  order.cartItems &&
                  order.cartItems[1] &&
                  order.cartItems[1].image
                ? `
                     <div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[1].image}" alt="product" />
                    </div>
              `
                : ''
            }
            ${
              order &&
              order.cartItems &&
              order.cartItems[2] &&
              order.cartItems[2].image &&
              order.cartItems[2].type == 'pizza' &&
              order.cartItems[2].isSlice != true
                ? `<div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[2].parent.image}" alt="product" />
                    </div>`
                : order &&
                  order.cartItems &&
                  order.cartItems[2] &&
                  order.cartItems[2].image
                ? `
                     <div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[2].image}" alt="product" />
                    </div>
              `
                : ''
            }
            ${
              order && order.cartItems && order.cartItems.length > 3
                ? `<div class="secondary-info-block secondary-info-block--count">
                    +${order.cartItems.length - 3}
                  </div>`
                : ''
            }
            </div>

            <div class="profile-info-block__buttons">
            ${
              order.status != 'cancelled'
                ? `<form method="POST" action="/orders/${order.id}/repeat">
                    <button type="submit" class="repeat-button placeholder-text bold profile-info-block__button"><svg
                      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 4V10H8" stroke="#343434" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M4.25916 14.6584C4.84276 16.2943 5.94888 17.6985 7.41087 18.6596C8.87287 19.6206 10.6115 20.0864 12.3649 19.9868C14.1182 19.8871 15.7913 19.2274 17.132 18.107C18.4727 16.9867 19.4084 15.4663 19.7981 13.7751C20.1878 12.0839 20.0104 10.3134 19.2926 8.73046C18.5748 7.14748 17.3556 5.83775 15.8185 4.99861C14.2815 4.15947 12.51 3.83639 10.7708 4.07803C9.0317 4.31968 7.4192 5.11297 6.1763 6.33837L2.5 9.5"
                        stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
              </form>
             `
                : ''
            }

            ${
              order.receiptUrl
                ? `<a href="${order.receiptUrl}" target="_blank" class="profile-info-block__button">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5 6C5 4.34315 6.34315 3 8 3H16C17.6569 3 19 4.34315 19 6V19C19 19.824 18.0592 20.2944 17.4 19.8L15.6327 18.4745C15.2619 18.1964 14.7485 18.2095 14.3925 18.5063L12.6402 19.9665C12.2693 20.2756 11.7307 20.2756 11.3598 19.9665L9.60753 18.5063C9.25145 18.2095 8.73814 18.1964 8.36734 18.4745L6.6 19.8C5.94076 20.2944 5 19.824 5 19V6Z"
                          stroke="#343434" stroke-width="2" />
                        <path d="M9 8H15" stroke="#343434" stroke-width="2" stroke-linecap="round" />
                        <path d="M9 12H15" stroke="#343434" stroke-width="2" stroke-linecap="round" />
                      </svg>
                    </a>`
                : ''
            }
            </div>
          </div>
`;

      orderItemMobile.innerHTML = `
          <a href="/profile/orders/${order.id}" class="history-order-link"></a>
          <div class="profile-info-block__header">
            <div class="profile-info-block__titles-wrapper">
              <h4 class="profile-info-block__title">Заказ ${
                order.number ? '№ ' + order.number : ''
              } от ${day}.${month}.${nextDate.getFullYear()}</h4> 
              <p class="profile-info-block__subtitle text-medium">
                
              ${statuses[order.orderType][order.status]}
              </p>
            </div>
            <div class="profile-info-block__price">
              ${priceString} ₽
            </div>
          </div>
          <div class="profile-info-block__wrapper">
            <div class="profile-info-block__body secondary-info-blocks">
            ${
              order &&
              order.cartItems &&
              order.cartItems[0] &&
              order.cartItems[0].image &&
              order.cartItems[0].type == 'pizza' &&
              order.cartItems[0].isSlice != true
                ? `<div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[0].parent.image}" alt="product" />
                    </div>`
                : order &&
                  order.cartItems &&
                  order.cartItems[0] &&
                  order.cartItems[0].image
                ? `
                     <div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[0].image}" alt="product" />
                    </div>
              `
                : ''
            }

            ${
              order &&
              order.cartItems &&
              order.cartItems[1] &&
              order.cartItems[1].image &&
              order.cartItems[1].type == 'pizza' &&
              order.cartItems[1].isSlice != true
                ? `<div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[1].parent.image}" alt="product" />
                    </div>`
                : order &&
                  order.cartItems &&
                  order.cartItems[1] &&
                  order.cartItems[1].image
                ? `
                     <div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[1].image}" alt="product" />
                    </div>
              `
                : ''
            }
            ${
              order &&
              order.cartItems &&
              order.cartItems[2] &&
              order.cartItems[2].image &&
              order.cartItems[2].type == 'pizza' &&
              order.cartItems[2].isSlice != true
                ? `<div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[2].parent.image}" alt="product" />
                    </div>`
                : order &&
                  order.cartItems &&
                  order.cartItems[2] &&
                  order.cartItems[2].image
                ? `
                     <div class="secondary-info-block secondary-info-block--medium">
                      <img class="secondary-info-block__icon" src="${order.cartItems[2].image}" alt="product" />
                    </div>
              `
                : ''
            }
            ${
              order && order.cartItems && order.cartItems.length > 3
                ? `<div class="secondary-info-block secondary-info-block--count">
                    +${order.cartItems.length - 3}
                  </div>`
                : ''
            }
            </div>

            <div class="profile-info-block__buttons">
            ${
              order.status != 'cancelled'
                ? `<form method="POST" action="/orders/${order.id}/repeat">
                    <button type="submit" class="repeat-button placeholder-text bold profile-info-block__button"><svg
                      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 4V10H8" stroke="#343434" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                      <path
                        d="M4.25916 14.6584C4.84276 16.2943 5.94888 17.6985 7.41087 18.6596C8.87287 19.6206 10.6115 20.0864 12.3649 19.9868C14.1182 19.8871 15.7913 19.2274 17.132 18.107C18.4727 16.9867 19.4084 15.4663 19.7981 13.7751C20.1878 12.0839 20.0104 10.3134 19.2926 8.73046C18.5748 7.14748 17.3556 5.83775 15.8185 4.99861C14.2815 4.15947 12.51 3.83639 10.7708 4.07803C9.0317 4.31968 7.4192 5.11297 6.1763 6.33837L2.5 9.5"
                        stroke="#343434" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
              </form>
             `
                : ''
            }

            ${
              order.receiptUrl
                ? `<a href="${order.receiptUrl}" target="_blank" class="profile-info-block__button">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5 6C5 4.34315 6.34315 3 8 3H16C17.6569 3 19 4.34315 19 6V19C19 19.824 18.0592 20.2944 17.4 19.8L15.6327 18.4745C15.2619 18.1964 14.7485 18.2095 14.3925 18.5063L12.6402 19.9665C12.2693 20.2756 11.7307 20.2756 11.3598 19.9665L9.60753 18.5063C9.25145 18.2095 8.73814 18.1964 8.36734 18.4745L6.6 19.8C5.94076 20.2944 5 19.824 5 19V6Z"
                          stroke="#343434" stroke-width="2" />
                        <path d="M9 8H15" stroke="#343434" stroke-width="2" stroke-linecap="round" />
                        <path d="M9 12H15" stroke="#343434" stroke-width="2" stroke-linecap="round" />
                      </svg>
                    </a>`
                : ''
            }
            </div>
          </div>
          `;

      historyOrdersList.append(orderItem);
      historyOrdersListMobile.append(orderItemMobile);
    });
  };

  if (moreHistoryOrdersButton) {
    moreHistoryOrdersButton.addEventListener('click', async () => {
      clearTimeout(ordersListTimeout);
      moreHistoryOrdersButton.textContent = 'Загрузка...';
      moreHistoryOrdersButton.classList.add('disabled');

      historyOrdersOffset += 10;
      historyOrdersCount += 10;

      const response = await fetchData(
        `/profile/orders/list/archived?offset=${historyOrdersOffset}`,
      );

      if (response) {
        moreHistoryOrdersButton.textContent = 'Показать еще';
        moreHistoryOrdersButton.classList.remove('disabled');

        if (!response.nextOrders.length) {
          moreHistoryOrdersButton.classList.remove('visible');
        }

        updateHistoryOrders(response.currentOrders);

        if (typeof updateOrdersLists === 'function') {
          updateOrdersLists();
        }
      }
    });
  }
  if (moreHistoryOrdersButtonMobile) {
    moreHistoryOrdersButtonMobile.addEventListener('click', async () => {
      clearTimeout(ordersListTimeout);
      moreHistoryOrdersButtonMobile.textContent = 'Загрузка...';
      moreHistoryOrdersButtonMobile.classList.add('disabled');

      historyOrdersOffset += 10;
      historyOrdersCount += 10;

      const response = await fetchData(
        `/profile/orders/list/archived?offset=${historyOrdersOffset}`,
      );

      if (response) {
        moreHistoryOrdersButtonMobile.textContent = 'Показать еще';
        moreHistoryOrdersButtonMobile.classList.remove('disabled');

        if (!response.nextOrders.length) {
          moreHistoryOrdersButtonMobile.classList.remove('visible');
        }

        updateHistoryOrders(response.currentOrders);

        if (typeof updateOrdersLists === 'function') {
          updateOrdersLists();
        }
      }
    });
  }

  if (activeOrdersList) {
    updateOrdersLists = () => {
      ordersListTimeout = setTimeout(async () => {
        moreHistoryOrdersButton.textContent = 'Загрузка...';
        moreHistoryOrdersButton.classList.add('disabled');

        const response = await fetchData(
          `/profile/orders?historyCount=${historyOrdersCount}`,
        );

        if (response) {
          if (response.activeOrders && response.activeOrders.length) {
            if (
              activeOrdersList &&
              activeOrdersList.classList.contains('hidden')
            ) {
              activeOrdersList.classList.remove('hidden');
            }

            if (
              activeOrdersEmptyText &&
              !activeOrdersEmptyText.classList.contains('hidden')
            ) {
              activeOrdersEmptyText.classList.add('hidden');
            }

            activeOrdersList.innerHTML = '';

            const activeOrders = response.activeOrders.map((order) => {
              let addressTitle = '<strong>Самовывоз</strong> из кафе:';

              if (order.orderType === 'delivery') {
                addressTitle = '<strong>Доставка</strong> по адресу:';
              } else if (order.orderType === 'cafe-togo') {
                addressTitle = '<strong>Обед в кафе</strong> по адресу:';
              } else if (order.orderType === 'cafe') {
                addressTitle = '<strong>В кафе</strong> по адресу:';
              }

              return `
              <li class="active-order row ${order.status}">
                <a href="/profile/orders/${order.id}" class="row">
                  <div class="status">
                    <div class="status-icon"></div>
                    <div class="status-text placeholder-text bold">${
                      statuses[order.orderType][order.status]
                    }</div>
                  </div>
                  <div class="order-text">
                    <div class="order-number italic very-small-text">${
                      order.number ? `Заказ №${order.number}` : ''
                    }</div>
                    <div class="order-address base-text">
                      <div>
                        ${addressTitle}
                      </div>
                      ${order.deliveryAddress}
                    </div>
                  </div>
                </a>
              </li>`;
            });

            activeOrdersList.innerHTML = activeOrders.join('');
          } else {
            if (
              activeOrdersList &&
              !activeOrdersList.classList.contains('hidden')
            ) {
              activeOrdersList.classList.add('hidden');
            }

            if (
              activeOrdersEmptyText &&
              activeOrdersEmptyText.classList.contains('hidden')
            ) {
              activeOrdersEmptyText.classList.remove('hidden');
            }
          }

          if (response.completedOrders && response.completedOrders.length) {
            if (
              historyOrdersList &&
              historyOrdersList.classList.contains('hidden')
            ) {
              historyOrdersList.classList.remove('hidden');
            }

            if (
              completeOrdersEmptyText &&
              !completeOrdersEmptyText.classList.contains('hidden')
            ) {
              completeOrdersEmptyText.classList.add('hidden');
            }

            historyOrdersList.innerHTML = '';
            updateHistoryOrders(response.completedOrders);
          } else {
            if (
              historyOrdersList &&
              !historyOrdersList.classList.contains('hidden')
            ) {
              historyOrdersList.classList.add('hidden');
            }

            if (
              completeOrdersEmptyText &&
              completeOrdersEmptyText.classList.contains('hidden')
            ) {
              completeOrdersEmptyText.classList.remove('hidden');
            }
          }

          moreHistoryOrdersButton.textContent = 'Показать еще';
          moreHistoryOrdersButton.classList.remove('disabled');

          clearTimeout(ordersListTimeout);
          updateOrdersLists();
        } else {
          moreHistoryOrdersButton.textContent = 'Показать еще';
          moreHistoryOrdersButton.classList.remove('disabled');

          clearTimeout(ordersListTimeout);
          updateOrdersLists();
        }
      }, 30000);
    };

    updateOrdersLists();
  }

  if (cardBindForm) {
    cardBindForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const endpoint = cardBindForm.getAttribute('action');
      const termUrlString = termUrlInput.value;

      cardSubmit.classList.add('loading');

      if (cardInputs) {
        [].forEach.call(cardInputs, (input) => input.classList.add('disabled'));
      }

      // CreatePayment({
      //   endpoint,
      //   termUrlString,
      // });
    });
  }

  if (logoutForm) {
    logoutForm.addEventListener('submit', () => {
      const formValuesFromSessionStorage = sessionStorage
        ? sessionStorage.getItem('formValues')
        : null;

      if (formValuesFromSessionStorage) {
        sessionStorage.removeItem('formValues');
      }
    });
  }
});

const addActionsToForm = (
  phoneInput,
  birthdayPicker,
  birthdayText,
  profileInformationForm,
  emailInput,
  emailSpecialOffer,
  emailSpecialOfferWrapper,
  confirmBirthdayWrapper,
  confirmBirthdayButton,
  profileName,
  profileNameErrors,
  birthdayInputClass,
) => {
  if (phoneInput && phoneInput.value.length) {
    mask(phoneInput, '+_ ___ ___ __ __');
  }

  if (profileName) {
    profileName.addEventListener('input', (e) => {
      const { value: initValue } = e.target;
      let value = initValue;

      if (value.match(/\s\s+/g)?.length > 1) {
        value = value.trim();
      }

      value = value
        .replace(/[^A-ZА-Я\-]/gi, ' ')
        .replace(/\s\s+/g, ' ')
        .substring(0, 24);

      profileName.value = value;

      if (value.length > 1) {
        profileNameErrors.innerHTML = '';
      }
    });
    profileName.addEventListener('blur', (e) => {
      profileName.value = profileName.value.trim();
    });
  }

  const months = [
    'Января',
    'Февраля',
    'Марта',
    'Апреля',
    'Мая',
    'Июня',
    'Июля',
    'Августа',
    'Сентября',
    'Октября',
    'Ноября',
    'Декабря',
  ];

  if (birthdayPicker) {
    pickmeup.defaults.locales['ru'] = {
      days: [
        'Воскресенье',
        'Понедельник',
        'Вторник',
        'Среда',
        'Четверг',
        'Пятница',
        'Суббота',
      ],
      daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
      months: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь',
      ],
      monthsShort: [
        'Янв',
        'Фев',
        'Мар',
        'Апр',
        'Май',
        'Июн',
        'Июл',
        'Авг',
        'Сен',
        'Окт',
        'Ноя',
        'Дек',
      ],
    };

    let date = new Date(Date.now());

    if (birthdayPicker.value) {
      date = new Date(birthdayPicker.value);

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      birthdayText.classList.remove('gray-text');
      birthdayText.textContent = `${day} ${month} ${year}`;
    }

    pickmeup(birthdayInputClass, {
      format: 'Y-m-d',
      locale: 'ru',
      date,
      hide_on_select: true,
      title_format: 'B',
      default_date: false,
    });

    birthdayPicker.addEventListener('pickmeup-change', (e) => {
      const { date } = e.detail;

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      if (birthdayText.classList.contains('gray-text')) {
        birthdayText.classList.remove('gray-text');
      }

      birthdayText.textContent = `${day} ${month} ${year}`;
    });
  }

  if (confirmBirthdayButton) {
    confirmBirthdayButton.addEventListener('click', () => {
      if (birthdayPicker) {
        birthdayPicker.dataset.value = birthdayPicker.value;
      }

      confirmBirthdayWrapper.classList.remove('active');
    });
  }

  if (emailInput) {
    emailInput.addEventListener('input', (e) => {
      const emailIsValid = /.+@.+\..+/gi.test(e.target.value);

      if (!emailIsValid) {
        emailInput.classList.add('error');
      } else {
        emailInput.classList.remove('error');

        if (emailSpecialOfferWrapper) {
          emailSpecialOfferWrapper.classList.remove('disabled');
        }

        if (emailSpecialOffer) {
          emailSpecialOffer.removeAttribute('disabled');
        }
      }
    });
  }

  if (profileInformationForm) {
    profileInformationForm.addEventListener('submit', (e) => {
      const birthday = birthdayPicker.value;
      const prevBirthday = birthdayPicker.dataset.value;

      if (profileName.value.length < 2) {
        e.preventDefault();
        profileNameErrors.innerHTML = '<li>Слишком короткое имя</li>';
      }

      if (prevBirthday !== birthday) {
        e.preventDefault();

        if (confirmBirthdayWrapper) {
          confirmBirthdayWrapper.classList.add('active');
        }
      }
    });
  }
};
